<template>
  <GlobalWindow
    title="废弃"
    :visible.sync="visible"
    :show="true"
    width="50%"
    @confirm="confirm"
    @closeDialog="close"
    @close="close"
  >
    <el-form label-width="100px">
      <el-form-item label="旧小说：">
        <!-- <el-autocomplete
          v-model="oldName"
          style="margin-right: 10px"
          :fetch-suggestions="querySearchAsync1"
          placeholder="小说名称"
          @select="handleSelect1"
        /> -->
        <el-input
          v-model="oldName"
          placeholder="请输入旧小说"
          :disabled="true"
        />
      </el-form-item>
      <el-form-item label="新小说：">
        <el-autocomplete
          v-model="newName"
          style="margin-right: 10px"
          :fetch-suggestions="querySearchAsync"
          placeholder="小说名称"
          @select="handleSelect"
        />
      </el-form-item>
    </el-form>
  </GlobalWindow>
</template>

<script>
import GlobalWindow from '@/components/GlobalWindow.vue'
import { novelAbandonment, novelScreening } from '@/api/report/novalList.js'
export default {
  components: {
    GlobalWindow
  },
  // 获取父组件筛选列表
  platformData: {
    type: Array,
    default: function() {
      return []
    }
  },
  data() {
    return {
      visible: false,
      newName: '',
      oldName: '',
      newID: undefined,
      oldID: undefined
    }
  },
  methods: {
    async querySearchAsync(queryString, callback) {
      var list = [{}]
      const response = await novelScreening({
        keyword: this.newName
      })
      for (const i of response.data.list) {
        i.value = i.name // 想要展示的数据 // 将想要展示的数据作为value
      }
      list = response.data.list
      console.log(list)
      callback(list)
    },
    async querySearchAsync1(queryString, callback) {
      var list = [{}]
      const response = await novelScreening({
        keyword: this.oldName
      })
      for (const i of response.data.list) {
        i.value = i.name // 想要展示的数据 // 将想要展示的数据作为value
      }
      list = response.data.list
      callback(list)
    },
    async confirm() {
      await novelAbandonment({
        old_novel_id: this.oldID,
        new_novel_id: this.newID
      })
      this.$message({
        message: '废弃小说成功',
        type: 'success'
      })
      this.visible = false
      this.oldName = undefined
      this.newName = undefined
      this.$emit('quedin')
    },
    close() {
      this.oldName = undefined
      this.newName = undefined
    },
    open(item) {
      this.oldID = item.id
      this.oldName = item.name
      this.visible = true
    },
    handleSelect(item) {
      this.newID = item.id
    },
    handleSelect1(item) {
      this.oldID = item.id
    }
  }
}
</script>

<style scoped lang="less">

</style>
